class AuthError extends Error {
  constructor(message = 'Authetication failed') {
    super(message);
    this.name = 'AuthError';
    Object.setPrototypeOf(this, AuthError.prototype);
  }
}
export default AuthError;
